module.exports = __webpack_public_path__ + "img/male.8da832c1.svg";